<div class="row mat-stepper-horizontal pt-4 pb-4">
  <div class="col-12 col-md-6 offset-md-3">
    <div class="row">
      <div class="col-12">
        <h2 *appApplyIfNotEmpty="translationService.getTranslation('login_box_header')"
            [innerHTML]="translationService.getTranslation('login_box_header')"></h2>
        <div *ngIf="loading || redirecting" style="text-align: center; margin:5px">
          <app-loading-spinner></app-loading-spinner>
        </div>
        <div *ngIf="useHassoForm; then hassoForm else inputFields"></div>
        <ng-template #hassoForm>
          <iframe id="ssoLoginFrame" title="" [src]="hassoLoginUrl" [style.height]="ssoFormPropagatedHeight"></iframe>
          <div *ngIf="!loading" class="btn-back">
            <button mat-raised-button color="primary" (click)="onBack()" [innerHTML]="translationService.getTranslation('button_back')"></button>
          </div>
        </ng-template>
        <ng-template #inputFields>
          <div class="mat-typography" [formGroup]="loginForm" (keyup.enter)="onLogin()">
            <div *ngIf="!loading" class="row">
              <div class="alert alert-danger" *ngIf="error" [innerHTML]="translationService.getTranslation(error)"></div>
              <div>
                <mat-form-field>
                  <mat-label [innerHTML]="translationService.getTranslation('login_email')"></mat-label>
                  <input matInput formControlName="email" type="text" required email name="username" autocomplete="off">
                  <mat-error>{{loginForm.get('email').getError('message')}}</mat-error>
                </mat-form-field>
              </div>
              <div>
                <mat-form-field>
                  <mat-label [innerHTML]="translationService.getTranslation('login_password')"></mat-label>
                  <input matInput formControlName="password" type="password" required name="password">
                  <mat-error>{{loginForm.get('password').getError('message')}}</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div>
            <button class="me-3" mat-raised-button color="primary" [disabled]="loading" (click)="onLogin()" [innerHTML]="translationService.getTranslation('login_login')"></button>
            <button mat-raised-button color="primary" [innerHTML]="translationService.getTranslation('login_close')"></button>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
